<template>
	<n-button quaternary circle size="small" class="back-button" @click="goBack">
		<template #icon>
			<Icon :size="20" name="carbon:chevron-left" />
		</template>
	</n-button>
</template>

<script lang="ts" setup>
import { NButton } from "naive-ui"
import Icon from "@/components/common/Icon.vue"
import { useRouter } from "vue-router"

const router = useRouter()

function goBack() {
	router.back()
}
</script>

<style lang="scss" scoped>
.back-button {
	flex-shrink: 0;
}
</style>
